import React from 'react';
import { Box, Grid, Skeleton, Card, CardContent } from '@mui/material';

interface CardSkeletonProps {
  count?: number;
  variant?: 'pays' | 'visa' | 'voyageur' | 'demande';
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({ count = 6, variant = 'pays' }) => {
  const items = Array.from({ length: count });

  if (variant === 'pays') {
    return (
      <Grid container spacing={2} sx={{ p: { xs: 1, sm: 2 } }}>
        {items.map((_, i) => (
          <Grid item xs={6} sm={4} md={3} key={i}>
            <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
              <Skeleton variant="rectangular" height={160} animation="wave" />
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  if (variant === 'voyageur') {
    return (
      <Grid container spacing={2}>
        {items.map((_, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Card sx={{ borderRadius: 3, p: 3, textAlign: 'center' }}>
              <Skeleton variant="circular" width={100} height={100} sx={{ mx: 'auto', mb: 2 }} animation="wave" />
              <Skeleton variant="text" width="60%" sx={{ mx: 'auto' }} animation="wave" />
              <Skeleton variant="text" width="40%" sx={{ mx: 'auto', mt: 1 }} animation="wave" />
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 2 }}>
                <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: 3 }} animation="wave" />
                <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: 3 }} animation="wave" />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // visa & demande share similar layout
  return (
    <Grid container spacing={2}>
      {items.map((_, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Card sx={{ borderRadius: 3 }}>
            <Box sx={{ height: 4, backgroundColor: '#e0e0e0' }} />
            <CardContent sx={{ p: 2.5 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Skeleton variant="rounded" width={100} height={24} sx={{ borderRadius: 3 }} animation="wave" />
                <Skeleton variant="rounded" width={50} height={24} sx={{ borderRadius: 3 }} animation="wave" />
              </Box>
              <Skeleton variant="rounded" width={48} height={32} sx={{ mx: 'auto', mb: 1, borderRadius: 1 }} animation="wave" />
              <Skeleton variant="text" width="70%" sx={{ mx: 'auto' }} animation="wave" />
              <Skeleton variant="text" width="50%" sx={{ mx: 'auto', mt: 1 }} animation="wave" />
              <Skeleton variant="circular" width={44} height={44} sx={{ mx: 'auto', mt: 2 }} animation="wave" />
              <Skeleton variant="text" width="40%" sx={{ mx: 'auto', mt: 1 }} animation="wave" />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default CardSkeleton;
